<script>
	let fake;
	import {fade} from 'svelte/transition';
	import Logo from '../components/Logo.svelte';
	import PatternBackground from '../components/PatternBackground.svelte';
	let change_bg_color = false;
	let green = false;
	let steps = [
		"#hero",
		"#experience",
		"#effect",
		"#format",
		"#sex",
		"#age",
		"#height",
		"#weight",
		"#result"
	];
	let prev;
	let state;
	let cart;
	let imgs;
	$: index = Math.floor(state.frequency / 2) * feels.length * formats.length + state.feel * formats.length + state.format;
	let gatekeeper;
	let black;
	let ps;
	let measurement_units;
	let first = 0;
	function reset_everything() {
		let temp = Date.now();
		if(temp - first < 1000) {
			console.log('did nothing');
			return;
		} else {
			if(first !== 0) {
				console.log('gtag')
				gtag('config', 'UA-128257793-3');
			}
			console.log('normal');
			first = temp;
			measurement_units = "imperial";
			black = true;
			document.documentElement.style.scrollBehavior = 'auto';
			requestAnimationFrame(() => requestAnimationFrame(() => {prev = location.hash = ''; document.documentElement.style.scrollBehavior = null;}));
			state = {};
			cart = false;
			imgs = [];
			if(ps !== undefined) {
				ps.clear();
			}
			gatekeeper = false;
		}
	}
	//$: console.log(state); idea: onchange send ga with timestamp. make previous unset the value and then we'll have full analytics??
	reset_everything();
	import Big from 'big.js';
	import { frequencies, feels, formats } from '../fn.mjs';
	let promise = calculate();
	let tstores;
	let tproducts;
	async function calculate() {
		let [nstores, nproducts] = await Promise.all([
			fetch('https://api.jsonbin.io/b/5db70785ce60505e47582601/latest').then(x => x.text()),
			fetch('products.json').then(x => x.text())
		]);
		if(nstores === tstores && nproducts === tproducts) {
			console.log('nothing to do');
			return;
		} else {
			tstores = nstores;
			tproducts = nproducts;
		}
		let stores = JSON.parse(nstores);
		let products = JSON.parse(nproducts);
		let query = (new URLSearchParams(location.search)).get('store');
		for(let i = 0; i < stores.length; ++i) {
			if(stores[i].name === query) {
				let cart = new Set();
				let diff = stores[i].diff || {};
				delete stores[i].diff;
				delete stores[i]['18'];
				for(const key in stores[i]) {
					if(Array.isArray(stores[i][key])) {
						for(let j = 0; j < stores[i][key].length; ++j) {
							let product_idx = stores[i][key][j];
							stores[i][key][j] = products[product_idx];
							for(const what in diff[product_idx]) {
								stores[i][key][j][what] = diff[product_idx][what];
							}
							delete diff[product_idx];
							stores[i][key][j].oldNumber = 0;
							stores[i][key][j].number = 0;
							stores[i][key][j].addedBy = new Set();
							stores[i][key][j].id = product_idx;
							cart.add(products[product_idx]);
						}
					}
				}
				for(const product of cart.values()) {
					if(product.price === undefined) {
						product.price = new Big(0);
					} else {
						product.price = new Big(product.price);
					}
					product.cbdminstr = (new Big(product.cbd_min)).times(100).toString();
					product.cbdmaxstr = (new Big(product.cbd_max)).times(100).toString();
					product.thcminstr = (new Big(product.thc_min)).times(100).toString();
					product.thcmaxstr = (new Big(product.thc_max)).times(100).toString();
				}
				stores[i].cart = cart;
				stores[i].cart_length = function() {
					let sum = 0;
					for(const product of this.cart.values()) {
						sum += product.number;
					}
					return sum;
				}
				stores[i].clear = function() {
					for(const product of this.cart.values()) {
						product.oldNumber = 0;
						product.number = 0;
					}
				}
				stores[i].subtotal = function(str = true) {
					let sum = new Big('0');
					for(const product of this.cart.values()) {
						sum = sum.plus(product.price.times(product.number));
					}
					if(str) {
						return sum.toFixed(2);
					} else {
						return sum;
					}
				}
				stores[i].compute_tax = function(add = false) {
					return this.subtotal(false).times(this.tax.add(add ? '1' : '0')).toFixed(2);
				}
				stores[i].total = function() {return this.compute_tax(true)};
				stores[i].tax = new Big(stores[i].tax);
				ps = stores[i];
				return;
			}
		}
		throw 'store not found';//handle no results in template(index)
	}
	import Product from '../components/Product.svelte';
	import Carousel from '../components/Carousel.svelte';
	import Buttons from '../components/Buttons.svelte';
	import Lightbox from '../components/Lightbox.svelte';
	import Cart from '../components/Cart.svelte';
	import debounce from 'just-debounce-it';
	let hero;
	let oldi = -1;
	let vh = document.documentElement.clientHeight;
	let reset = 0;
	let resetTime = 0;
	async function load_animation() {
		fake.style.opacity = 1;
		fake.src = 'dna_helix.svg';
		gatekeeper = true;
		await Promise.all([
			new Promise(resolve => setTimeout(resolve, 2000)),
			calculate()
		]);
		fake.style.transition = 'opacity 1s linear';
		fake.style.opacity = 0;
	}
</script>

<svelte:window
	on:hashchange={e => {
		dataLayer.push({
			event: 'pageviewCustomEvent',
			pagePath: '/' + location.hash,
			pageTitle: location.hash
		})
		let event;
		let eventAction;
		switch(oldi) {
			case 0:
				event = 'experience';
				eventAction = state.frequency;
				break;
			case 1:
				event = 'effect';
				eventAction = state.feel;
				break;
			case 2:
				event = 'format';
				eventAction = state.format;
				break;
			case 3:
				event = 'sex';
				eventAction = state.sex;
				break;
			case 4:
				event = 'age';
				eventAction = state.age;
				break;
			case 5:
				event = 'height';
				eventAction = state.height;
				break;
			case 6:
				event = 'weight';
				eventAction = state.weight;
				break;
		}
		if(event !== undefined) {
			dataLayer.push({
				event: event,
				eventAction: eventAction
			});
		}
		let i = steps.indexOf(location.hash) - 1;
		if(i < 0) {
			resetTime = 0;
			hero.style.backgroundImage = null;
		} else if(i === steps.length - 2) {
			resetTime = 180000;
		} else {
			resetTime = 60000;
			prev = steps[i];
		}
		clearTimeout(reset);
		reset = setTimeout(reset_everything, resetTime);
		if(oldi >= 0 && i >= 0 && i < steps.length - 2) {
			change_bg_color = true;
		}
		oldi = i;
	}}
	on:resize={debounce(() => {
		vh = document.documentElement.clientHeight;
		if(steps.indexOf(location.hash) !== -1) {
			document.documentElement.style.scrollBehavior = 'auto';
			requestAnimationFrame(() => {
				document.getElementById(location.hash.slice(1)).scrollIntoView();
				document.documentElement.style.scrollBehavior = null;
			});
		}
	}, 100, true)}
	on:load={() => {
		document.documentElement.style.scrollBehavior = 'auto';
		requestAnimationFrame(() => {
			window.scroll(0,0);
			document.documentElement.style.scrollBehavior = null;
		});
	}}
	on:scroll={() => {
		if(scrollY % vh === 0) {
			if(change_bg_color) {
				change_bg_color = false;
				green = !green;
			}
			if(hero.style.backgroundImage !== "none" && scrollY >= vh && oldi >= 0) {
				hero.style.backgroundImage = "none";
			}
		}
	}}
	on:click={() => {
		clearTimeout(reset);
		reset = setTimeout(reset_everything, resetTime);
	}}
/>

<style>
	:global(html) {
		scroll-behavior: smooth;
		touch-action: none;
	}
	.page {
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		font-weight: 500;
		font-family: 'nunito sans';
	}
	.page > header {
		margin-bottom: 30px;
		text-align: center;
		max-width: min(75rem, 80%);
	}
	.page > header > h2 {
		margin-bottom: .25em;
		margin-top: 0;
		font-size: 4rem;
		text-transform: uppercase;
		letter-spacing: 0.8px;
		font-weight: 700;
		line-height: 1.3em;
		font-family: barlow;
	}
	.page > header > div {
		font-size: 2.2rem;
		font-family: barlow;
		font-weight: 700;
	}
	.subtitle::after {
		content: "";
		display: block;
		width: 40px;
		height: 2px;
		margin: 30px auto 0;
		background: #333F48;
	}
	.page > p {
		margin-top: 0;
		max-width: min(75rem, 80%);
		font-size: 1.5em;
		text-align: center;
	}
	#hero {
		background-color: white;
		background-size: cover;
		background-position: center;
		will-change: transform;
		background-image: url('hexagon.svg');
	}
	.qbox {
		justify-content: center;
		flex-wrap: wrap;
		display: flex;
		max-width: 70em;
	}
	#dna_helix_animation {
		position: fixed;
		width: 50vw;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
	#result {
		background: white;
		will-change: transform;
	}
	select {
		border-radius: 21px;
		border: none;
		padding-top: .6em;
		padding-bottom: .6em;
		padding-left: 1em;
		padding-right: 2em;
		margin: 0 .5em;
		-webkit-appearance: none;
		background: #E9E9E9 url(arrow-down.svg) right 15% center no-repeat;
		font-family: 'nunito sans';
		font-size: 1em;
	}
	.hell {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		padding: 2em;
		display: flex;
		align-items: center;
		margin-bottom: 2em;
		background-color: #f7f9fa;
		border-bottom: solid #d2d3d3;
	}
	.hide {
		opacity: 0;
	}
	#realresult {
		transition: opacity .5s linear;
	}
	.unitstogglelist {
		display: flex;
		justify-content: center;
		margin-top: 4em;
	}

	.unitstoggle {
		width: 9em;
		padding: .5em .75em;
		background: #FFF;
		font-size: 1.3em;
		border: 2px solid #E9E9E9;		
	}

	.unitstoggle:focus {
		outline: none;
	}

	.unitstoggle:first-child {
		border-radius: .5em 0 0 .5em;
		border-right-width: 0;
	}

	.unitstoggle + .unitstoggle {
		border-left-width: 0;
	}

	.unitstoggle:last-child {
		border-radius: 0 .5em .5em 0;
	}


	.unitstoggle.active {
		color: #006BA6;
		background: #F7F9FA;
		font-weight: bold;
		border: 2px solid #006BA6;
	}
</style>

<svelte:head>
<link href="https://fonts.googleapis.com/css?family=Barlow|Nunito+Sans&display=swap" rel="stylesheet">
</svelte:head>

<PatternBackground bind:green />

<Buttons
	style="
		font-family: 'nunito sans';
		position: fixed;
		left: 0;
		top: 0;
		width: auto;
		color: rgb(0, 107, 166);
		background: white;
		font-size: .9em;
		font-weight: normal;
		padding-left: .5em;
		padding-right: .5em;
	"
	bind:hash={prev}
	contents={[oldi <= 0 ? 'start over' : 'previous step']}
/>

<div bind:this={hero} id="hero" class="page" style="height: {vh}px">
	<Logo style="
		fill: rgb(51, 63, 72);
		height: 11em;
		margin-bottom: 4em;
	"/>
	<header>
		<h2>Discover cannabis strains based on your genes</h2>
	</header>
	<p>Let’s learn a bit about you. It takes less than 30 seconds and is anonymous.</p>
	<Buttons
		style="font-family: 'nunito sans'"
		contents={['Get Started']}
		hash="#experience"
		bind:state={state.started}
	/>
</div>

<div id="experience" class="page" style="height: {vh}px">
	<header>
		<h2>Experience</h2>
		<div class="subtitle">How often do you use cannabis?</div>
	</header>
	<p>The potency of THC in your recommendations is influenced by your experience level.</p>
	<div class='qbox'>
		<Buttons
			style="font-family: 'nunito sans'"
			contents={[
				'DAILY',
				'WEEKLY',
				'MONTHLY',
				'RARELY'
			]}
			hash="#effect"
			bind:state={state.frequency}
		/>
	</div>
</div>

<div id="effect" class="page" style="height: {vh}px">
	<header>
		<h2>Desired Effect</h2>
		<div class="subtitle">How do you want to feel?</div>
	</header>
	<div class='qbox'>
		<Buttons
			style="font-family: 'nunito sans'"
			contents={[
				'ENERGETIC & UPLIFTED<br>(Sativa Dominant)',
				'CALM & BALANCED<br>(CBD : THC)',
				'CHILL & RELAXED<br>(Indica Dominant)'
			]}
			hash="#format"
			bind:state={state.feel}
		/>
	</div>
</div>

<div id="format" class="page" style="height: {vh}px">
	<header>
		<h2>Format</h2>
		<div class="subtitle">What’s your preferred method?</div>
	</header>
	<div class='qbox'>
		<Buttons
			style="font-family: 'nunito sans'"
			contents={[
				'FLOWER',
				'PRE-ROLL',
				'OILS & CAPSULES'
			]}
			hash="#sex"
			bind:state={state.format}
		/>
	</div>
</div>

<div id="sex" class="page" style="height: {vh}px">
	<header>
		<h2>Sex</h2>
		<div class="subtitle">What is your sex?</div>
	</header>
	<p>Cannabis can have a different effect on males versus females.</p>
	<div class='qbox'>
		<Buttons
			style="font-family: 'nunito sans'"
			contents={[
				'MALE',
				'FEMALE',
				'OTHER'
			]}
			hash="#age"
			bind:state={state.sex}
		/>
	</div>
</div>

<div id="age" class="page" style="height: {vh}px">
	<header>
		<h2>Age</h2>
		<div class="subtitle">How old are you?</div>
	</header>
	<p>Your age can influence the effects of cannabis.</p>
	<div class='qbox'>
		<Buttons
			style="font-family: 'nunito sans'"
			contents={[
				'19 - 24',
				'25 - 39',
				'40 - 60',
				'60+'
			]}
			hash="#height"
			bind:state={state.age}
		/>
	</div>
</div>

<div id="height" class="page" style="height: {vh}px">
	<header>
		<h2>Height</h2>
		<div class="subtitle">How tall are you?</div>
	</header>
	<p>Your body mass index (BMI) is one element that contributes to how cannabis affects your body.</p>

	<div class='qbox'>
		<Buttons
			style="font-family: 'nunito sans'"
			contents={measurement_units === "metric" ? [
				"UNDER 154cm",
				"155cm - 167cm",
				"168cm - 182cm",
				"183cm +"
			] : [
				`UNDER 5'0"`,
				`5'1" - 5'6"`,
				`5'7" - 6'0"`,
				`6'1" +`
			]}
			hash="#weight"
			bind:state={state.height}
		/>
	</div>
	<div class="unitstogglelist">
		<button class:active={measurement_units === "imperial"} class="unitstoggle" on:click={() => {measurement_units = "imperial"}}>Imperial</button>
		<button class:active={measurement_units === "metric"} class="unitstoggle" on:click={() => {measurement_units = "metric"}}>Metric</button>
	</div>
</div>

<div id="weight" class="page" style="height: {vh}px">
	<header>
		<h2>Weight</h2>
		<div class="subtitle">How much do you weigh?</div>
	</header>
	<p>This is another factor in estimating your BMI.</p>
	<div class='qbox'>
		<Buttons
			style="font-family: 'nunito sans'"
			contents={measurement_units === "metric" ? [
				"UNDER 45kg",
				"46kg - 67kg",
				"68kg - 90kg",
				"91kg +"
			] : [
				"UNDER 100lbs",
				"101lbs - 149lbs",
				"150lbs - 199lbs",
				"200lbs +"
			]}
			hash="#result"
			bind:state={state.weight}
			fn={load_animation}
		/>
	</div>
	<div class="unitstogglelist">
		<button class:active={measurement_units === "imperial"} class="unitstoggle" on:click={() => {measurement_units = "imperial"}}>Imperial</button>
		<button class:active={measurement_units === "metric"} class="unitstoggle" on:click={() => {measurement_units = "metric"}}>Metric</button>
	</div>
</div>

<div id="result" style="height: {vh}px">
	<img bind:this={fake} id="dna_helix_animation" on:transitionend={() => {black = false; fake.style.transition = null; fake.src = ""}} />
	{#await promise then fuck}
		<div id="realresult" class:hide={black} class="page" style="height: 100%">
			<div class="hell">
				Items {ps.cart_length()}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;Total {ps.total()}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;Tax {ps.compute_tax()}
				<a on:click|preventDefault={() => {
					if(ps.cart_length()) {
						cart = true;
						dataLayer.push({
							event: 'cart_open',
							eventAction: 0
						});
					} else {
						dataLayer.push({
							event: 'cart_cant_open',
							eventAction: 0
						});
					}
				}} href="#" style="margin-left: auto; margin-right: 1em; text-decoration: none;">View my cart >></a>
				<svg on:click={() => {
					if(ps.cart_length()) {
						cart = true;
						dataLayer.push({
							event: 'cart_open',
							eventAction: 1
						});
					} else {
						dataLayer.push({
							event: 'cart_cant_open',
							eventAction: 1
						});
					}
				}} viewBox="0 0 41 38" width="3em"><!-- "0 0 36 34" -->
					<path transform="translate(0,4)" d="m6.48 3.79h-4.39c-.88 0-1.6-.72-1.6-1.6s.72-1.6 1.6-1.6h4.39c.88 0 1.6.72 1.6 1.6s-.72 1.6-1.6 1.6zm27.41 6.07h-26.07c-.88 0-1.6-.72-1.6-1.6 0-.89.72-1.6 1.6-1.6h26.07c.88 0 1.59.71 1.59 1.6 0 .88-.71 1.6-1.59 1.6zm-4.96 17.02h-18.96c-.88 0-1.6-.72-1.6-1.6s.72-1.6 1.6-1.6h18.96c.88 0 1.59.72 1.59 1.6s-.71 1.6-1.59 1.6zm1.01-5.54h-20.72c-.88 0-1.6-.71-1.6-1.59 0-.89.72-1.6 1.6-1.6h20.72c.88 0 1.6.71 1.6 1.6 0 .88-.72 1.59-1.6 1.59zm-19.97 5.54c-.78 0-1.46-.57-1.58-1.36l-3.49-23.09c-.14-.87.46-1.69 1.34-1.82.87-.13 1.69.47 1.82 1.34l3.49 23.09c.14.88-.46 1.69-1.34 1.82-.08.01-.16.02-.24.02zm19.97-5.54c-.17 0-.35-.02-.52-.08-.83-.29-1.28-1.2-.99-2.03l3.94-11.55c.29-.83 1.2-1.28 2.03-.99.84.28 1.28 1.19 1 2.03l-3.95 11.54c-.22.67-.85 1.08-1.51 1.08zm-20.72 9.48c0 1.36 1.1 2.45 2.45 2.45 1.36 0 2.45-1.09 2.45-2.45 0-1.35-1.09-2.45-2.45-2.45-1.35 0-2.45 1.1-2.45 2.45zm14.8 0c0 1.36 1.1 2.45 2.45 2.45 1.36 0 2.46-1.09 2.46-2.45 0-1.35-1.1-2.45-2.46-2.45-1.35 0-2.45 1.1-2.45 2.45z" fill="{ps.cart_length() ? 'rgb(51, 63, 72)' : 'rgb(127, 127, 127)'}"/>
					{#if ps.cart_length()}
						<circle fill="#E02020" r="8" cx="33" cy="8"></circle>
						<text alignment-baseline="central" text-anchor="middle" fill="white" font-size="10px" x="33" y="8">{ps.cart_length()}</text>
					{/if}
				</svg>
			</div>
			<header style="margin-top: 10em">
				<div>
					{#if !gatekeeper || !Array.isArray(ps[index])}
						Sorry, we don't have enough data about people like you :(
					{:else}
						YOUR TOP {ps[index].length > 1 ? ps[index].length : ''} STRAIN SUGGESTION{ps[index].length > 1 ? 'S' : ''} BASED ON SCIENCE
					{/if}
				</div>
			</header>
			<div style="margin-bottom: 2em">
				<select on:change={() => {
					dataLayer.push({
						event: 'change_effect',
						eventAction: state.feel
					});
					for(const product of ps[index].values()) {
						if(product.number) {
							product.addedBy.add(state.feel);
						}
					}
				}} bind:value={state.feel}>
					<option hidden disabled selected value={undefined}></option>
					{#each feels as feel, i}
						<option value={i}>
							{feel}
						</option>
					{/each}
				</select>
				<select on:change={() => {
					dataLayer.push({
						event: 'change_format',
						eventAction: state.format
					});
				}} bind:value={state.format}>
					<option hidden disabled selected value={undefined}></option>
					{#each formats as format, i}
						<option value={i}>
							{format.join(' & ')}
						</option>
					{/each}
				</select>
			</div>
			{#if gatekeeper && Array.isArray(ps[index])}
				<Carousel feel={state.feel} bind:imgs bind:products={ps[index]} />
			{/if}
			{#if imgs.length}
				<Lightbox bind:imgs />
			{/if}
			{#if cart}
				<Cart f={state.frequency} bind:visible={cart} bind:list={ps} />
			{/if}
			<div class='qbox'>
				<Buttons style="background: white;color: rgb(0, 107, 166);width: 10em;font-family: 'nunito sans'" contents={['START OVER']} fn={reset_everything} active={false} />
				{#if ps.cart_length()}
					<Buttons style="font-family: 'nunito sans'; width: 0" contents={['']} fn={() => {
						cart = true;
						dataLayer.push({
							event: 'cart_open',
							eventAction: 2
						});
					}} animate="VIEW MY CART" active={false} />
				{/if}
			</div>
			{#if gatekeeper && Array.isArray(ps[index])}<p>
				Health Canada wants you to stay safe:
				{#if state.frequency === 0}
					know and follow the rules about where you can use cannabis in your community
				{:else if state.frequency === 1}
					avoid combining cannabis with alcohol and / or other substances as it increases impairment.
				{:else if state.frequency === 2}
					use cannabis in a safe and familiar environment and with people you trust.
				{:else if state.frequency === 3}
					start low and go slow. Choose lower potency THC products and consider strains with CBD
				{/if}
			</p>{/if}
		</div>
	{/await}
</div>